import React,{ useEffect, useState }  from "react";
import LinkButton from "../LinkButton";
import ReviewsCarousel from "../ReviewsCarousel";
import * as styles from "./style.module.css";
import { ReviewsBlockProps } from "../interface/interface";

const ReviewsBlock: React.FC<ReviewsBlockProps> = ({home, trainer}) => {
  const [slides, setSlides] = useState<string>("");

  useEffect(() => {
    if (home) {
      setSlides("home");
    }
    if (trainer) {
      setSlides("trainer");
    }
  }, [home, trainer]);
  
return (
  <section className={`${home ? styles.container : ""}${trainer ? styles.trainercontainer : ""}`}>
    {home && <div className={styles.heading}>#TeamGainful Reviews</div>}
    {trainer && <div className={styles.heading}>member reviews</div>}
    <ReviewsCarousel slides={slides} />
    <LinkButton text="Read more reviews" href="/reviews/" style={{display: "flex", margin: "0 auto"}} />
  </section>
)};

export default ReviewsBlock;
